<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppMonthYearSelector',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      currentView: 'Years',
      selectedValue: this.modelValue ?? '',
    }
  },
  methods: {
    onSelectDate(value: string) {
      const view = this.currentView === 'Years' ? 'Months' : 'Years'
      this.selectedValue = value
      this.$refs.refDate.setView(view)
      if (this.currentView === 'Months') {
        this.$refs.refPopup.hide()
      }

      this.currentView = view
      this.$emit('update:modelValue', this.selectedValue)
    },
    setDefaultValue() {
      if (this.modelValue) {
        this.selectedValue = this.modelValue
      } else {
        const date = new Date()
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        this.selectedValue = `${year}-${month}`
        this.$emit('update:modelValue', this.selectedValue)
      }
    },
  },
  mounted() {
    this.setDefaultValue()
  },
})
</script>

<template>
  <q-input outlined dense :model-value="selectedValue" readonly>
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="refPopup">
          <q-date
            ref="refDate"
            minimal
            mask="YYYY-MM"
            v-model="selectedValue"
            default-view="Years"
            outlined
            dense
            emit-immediately
            @update:model-value="onSelectDate"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>
